export const PermissionAuthority = {
    GET: "mgr-authorities-**-GET",
};